enum Screens {
    welcome,
    phoneNumber,
    confirmationCode,
    getStarted,
    selectGroup,
    createGroup,
    hlPrivacySetting,
    // addBioGroup,
    addWelcomePost,
    groupSettingScreen,
    email,
    onboarding1,
    onboarding2,
    landingPage,
    linkDetails,
    generateLink,
    previewScreen,
}

export default Screens;
